import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const ArrowsContainer = styled.div`
  position: absolute;
  z-index: 5;
  left: 0;
  right: 0;
  bottom: 0;
`

type ArrowButtonProps = {
  isActive: boolean
  isPrevious?: boolean
  isNext?: boolean
}

export const ArrowButton = styled.div<ArrowButtonProps>`
  position: absolute;
  bottom: 0;
  opacity: 0.6;
  cursor: default;
  height: 30px;
  width: 30px;
  transition: opacity 0.2s ease;

  ${({ theme }) => `
    svg {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 20px;
      height: 16px;

      path {
        stroke: ${theme.color.white};
      }
    }
  `}

  ${({ isActive }) =>
    isActive &&
    `
    opacity: 1;
    cursor: pointer;
  `}

  ${({ theme, isPrevious }) =>
    isPrevious &&
    `
    left: -${theme.space.mobile.nano};
    transform: rotate(-180deg);
  `}

  ${({ theme, isNext }) =>
    isNext &&
    `
    right: -${theme.space.mobile.nano};
  `}

  ${media.sm`
    svg {
      width: 22px;
      height: 18px;
    }
  `}
`
